var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useApiQuery } from '../../../../infra/api';
import { endpoints } from '../endpoints';
import { useSession } from '../../../../infra/session';
export var useActiveBrandTax = function (taxId, options) {
    if (options === void 0) { options = {}; }
    var session = useSession().data;
    var brand = ((session === null || session === void 0 ? void 0 : session.view) || { viewer: null }).viewer;
    return useApiQuery({
        endpoint: endpoints.brandTaxQuery,
        payload: {
            taxId: taxId,
            brandId: brand === null || brand === void 0 ? void 0 : brand.id,
        },
        options: __assign(__assign({}, options), { enabled: !!brand && !!taxId }),
    });
};
